export default __webpack_public_path__ + "static/media/mobileHomePageImage.dfac33ac.png";